var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "attendance-table-container" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "sk-table custom-attendance-table",
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.items,
              border: "",
              "max-height": _vm.$tableMaxHeight,
            },
            on: { "selection-change": _vm.handleSelectionChange },
          },
          [
            _c("el-table-column", {
              attrs: {
                type: "selection",
                width: "50",
                align: "center",
                fixed: "left",
              },
            }),
            _c("el-table-column", {
              attrs: {
                type: "index",
                label: "STT",
                width: "55",
                align: "center",
                fixed: "left",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "Học sinh",
                prop: "nameStudent",
                "min-width": "200",
                fixed: "left",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("div", { staticClass: "student-profile-cell" }, [
                        _c("span", { staticClass: "student-name-text" }, [
                          _vm._v(_vm._s(row.nameStudent || "")),
                        ]),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "Trạng thái",
                width: "130",
                align: "center",
                fixed: "left",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("div", { staticClass: "status-cell" }, [
                        _c(
                          "span",
                          {
                            class: [
                              "status-badge",
                              `status-badge--${row.status.toLowerCase()}`,
                            ],
                          },
                          [
                            _vm._v(
                              "\n      " + _vm._s(_vm.getStatus(row)) + "\n    "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "Lớp", width: "120", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("div", { staticClass: "status-cell" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(row.className || "") +
                            "\n          "
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "Ngày tạo", width: "150", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("div", { staticClass: "status-cell" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm._f("formatDateTime")(row.createdDate)) +
                            "\n          "
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "Xử lý", width: "200", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("div", { staticClass: "status-cell" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(row.nameConfirm) +
                            "\n            "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm._f("formatDateTime")(row.confirmDate)) +
                            "\n          "
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "Nội dung", width: "300" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("div", { staticClass: "content-wrapper" }, [
                        _c(
                          "div",
                          {
                            class: [
                              "content-text",
                              {
                                "is-collapsed": !_vm.expandedRows.includes(
                                  row.id || row.nameStudent
                                ),
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(row.content) +
                                "\n            "
                            ),
                          ]
                        ),
                        row.content && row.content.length > 150
                          ? _c(
                              "span",
                              {
                                staticClass: "toggle-content-btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleExpand(row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n      " +
                                    _vm._s(
                                      _vm.expandedRows.includes(
                                        row.id || row.nameStudent
                                      )
                                        ? "Rút gọn"
                                        : "Xem thêm"
                                    ) +
                                    "\n    "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "Ngày nghỉ", width: "200", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("formatDate")(row.fromDate)) +
                          " - " +
                          _vm._s(_vm._f("formatDate")(row.toDate)) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "Số lượng ảnh", width: "95", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(row.attachments.length) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "Tác vụ",
                align: "center",
                width: "200",
                fixed: "right",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c(
                        "div",
                        { staticClass: "action-buttons-wrapper" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "row-action-btn btn-edit",
                              attrs: {
                                type: "success",
                                disabled: row.status !== "PENDING",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleApproved(row)
                                },
                              },
                            },
                            [_vm._v("Duyệt\n            ")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "row-action-btn btn-cancel",
                              attrs: {
                                type: "danger",
                                disabled: row.status === "APPROVED",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleDelete(row)
                                },
                              },
                            },
                            [_vm._v("Xoá\n            ")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "row-action-btn btn-save",
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleDetail(row)
                                },
                              },
                            },
                            [_vm._v("Chi tiết\n            ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }